import gql from "@insightfulscience/shared-utils/gqlClient/gql";

let cache = null;
let lastUpdate = new Date().getTime();
const cacheTime = 60_000; // 60s

const MAINTENANCE_INFO = gql`
	query maintenanceInfo {
		getServerInfo {
			brandMaintenance
		}
	}
`;

export const maintenanceProvider = gqlClient => {
	if (cache !== null && new Date().getTime() < lastUpdate + cacheTime) {
		return Promise.resolve(cache);
	}

	return gqlClient(MAINTENANCE_INFO)
		.then(({ getServerInfo: { brandMaintenance } }) => brandMaintenance)
		.then(v => {
			cache = v;
			lastUpdate = new Date().getTime();
			return v;
		});
};
